import React from "react";
import { DataGrid as MuiDataGrid } from "@mui/x-data-grid";

import CustomToolbar from "../custom-toolbar/custom-toolbar";

import css from "./datagrid.module.css";

const DataGrid = ({
  toolbarTitle,
  toolbarBtnTitle,
  toolbarOnClick,
  toolbarBtnVisible,
  ...rest
}) => {
  // console.log('DataGrid rest', rest)
  const propsDataGrid = {
    classes: { root: css.dataGrid },
    slots: {
      toolbar: () => (
        <CustomToolbar
          title={toolbarTitle}
          btnTitle={toolbarBtnTitle}
          onClick={toolbarOnClick}
          toolbarBtnVisible={toolbarBtnVisible}
        />
      ),
    },
    ...rest,
  };

  return (
    <div className={css.dataGrid}>
      <MuiDataGrid {...propsDataGrid} />
    </div>
  );
}

export default DataGrid;
